import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, SxProps, TextField } from "@mui/material";
import React from "react";

type Props = {
  label?: string;
  sx?: SxProps;
  value: string;
  onChange: (v: string) => void;
  onBlur?: (v: string) => void;
  error?: { state: boolean; message: string };
};

const SearchField = ({ label, sx, value, onBlur, onChange, error }: Props) => {
  return (
    <TextField
      label={label}
      sx={{ ...sx }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      onBlur={(e) => onBlur && onBlur(e.target.value)}
      variant="outlined"
      InputProps={{
        style: {
          border: "1px solid #EAEAEB",
          borderRadius: "6px",
          backgroundColor: "#F2F2F3",
        },
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      error={error?.state}
      helperText={error?.state && error.message}
      inputProps={{ maxLength: 128 }}
    />
  );
};

export default SearchField;
